import React from 'react';

import { PdfBadge, PdfBadgeRow, PdfEmptyText } from './PdfExport.styles';

interface PdfBadgesProps {
  /** Items to render as individual badges. */
  items: string[];
  /** Placeholder text shown when `items` is empty. */
  emptyText: string;
  /** When true, all badges are rendered in the severe (red) variant. */
  severe?: boolean;
  /** When true, badges use a square-ish radius (`chip`). Default is pill. */
  chip?: boolean;
}

/**
 * Renders a wrapping row of PDF badge pills/chips.
 * Falls back to italic empty text when the list is empty.
 */
export default function PdfBadges({
  items,
  emptyText,
  severe = false,
  chip = false,
}: PdfBadgesProps) {
  if (items.length === 0) {
    return <PdfEmptyText>{emptyText}</PdfEmptyText>;
  }

  return (
    <PdfBadgeRow>
      {items.map((item, index) => (
        <PdfBadge
          key={`${item}-${index}`}
          shape={chip ? 'chip' : 'pill'}
          variant={severe ? 'severe' : 'default'}
        >
          {item}
        </PdfBadge>
      ))}
    </PdfBadgeRow>
  );
}
